import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
// import * as iink from "iink-js";
import { Button } from "@material-ui/core";
import html2canvas from "html2canvas";

const WritingPad = ({ fullScreen, submitBtnText, onSubmit, role, onUndo }) => {
  const editorRef = useRef(null);
  const undoRef = useRef(null);
  const [disableBtns, setDisableBtns] = useState(true);
  const [data, setData] = useState({ latex: "", mathml: "", src: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [editorInstance, setEditorInstance] = useState(null);

  const clearPad = () => {
    if (editorInstance) {
      editorInstance?.clear();
    } else if (editorRef.current?.editor) {
      editorRef.current.editor.clear();
    }
  };

  const captureHandwrittenContent = 
    (value, captureAndSubmit, exportedData) => {
    let responseData = null;
    setIsLoading(true);
    axios
      .post(
        "https://api.mathpix.com/v3/text",
        {
          src: value,
          formats: ["text", "html", "data"],
          data_options: {
            include_mathml: true,
            include_asciimath: true,
            include_latex: true,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            app_key:
              "d62ecb4446b14bd94a84d181e9ad8a17b282616ccb2fd3686a2e02614100ae8b",
          },
        }
      )
      .then((response) => {
        const mathpixData = response.data;
        if (mathpixData && mathpixData.text) {
          if (
            !exportedData.latex.includes("=") &&
            exportedData.latex.includes("\\")
          ) {
            let dataLatex = exportedData.latex.replace(/\\\( | \\\)/g, "");
            const length = dataLatex.length;
            const midpoint = Math.floor(length / 2);
            const subString1 = dataLatex.slice(0, midpoint);
            const subString2 = dataLatex.slice(midpoint);
            let modifiedLatex =
              "\\(" + subString1 + "\\quad" + "\\quad" + subString2 + "\\)";
            responseData = {
              latex: modifiedLatex,
              mathml: mathpixData.html,
              asciimath: mathpixData.data.find(
                (item) => item.type === "asciimath"
              )?.value,
              src: value,
            };
          } else if (
            !exportedData.latex.includes("=") &&
            !exportedData.latex.includes("\\") &&
            role === "Student"
          ) {
            let firstPart = exportedData.latex.substring(0, 2); // "-1"
            let secondPart = exportedData.latex.substring(2);
            let modifyLatex =
              firstPart + " " + " " + " " + " " + " " + secondPart; // "-1 -1"

            responseData = {
              latex: modifyLatex,
              mathml: mathpixData.html,
              asciimath: mathpixData.data.find(
                (item) => item.type === "asciimath"
              )?.value,
              src: value,
            };
          } else {
            responseData = {
              latex: mathpixData.text,
              mathml: mathpixData.html,
              asciimath: mathpixData.data.find(
                (item) => item.type === "asciimath"
              )?.value,
              src: value,
            };
          }
          setData(responseData);
          captureAndSubmit && onSubmit(responseData);
          setIsLoading(false);
          if (role === "Student") {
            clearPad();
            setDisableBtns(true);
          }
        } else {
          responseData = { latex: "", mathml: "", asciimath: "", src: "" };
          setData(responseData);
          captureAndSubmit && onSubmit(responseData);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error calling Mathpix API:", error);
        setIsLoading(false);
        responseData = { latex: "", mathml: "", asciimath: "", src: "" };
        setData(responseData);
        captureAndSubmit && onSubmit(responseData);
      });
  };

  const captureSnapshot = async(captureAndSubmit, exportedData) => {
    try {
      // Get the DOM element for the editor
      const editorElement = editorRef.current;

      // Capture the content of the editor as an image
      const canvas = await html2canvas(editorElement);

      // Convert the canvas to a blob
      canvas.toBlob(async (blob) => {
        const response = await blobToBase64(blob);

        // if you want to see blob url uncommented below line
        // const blobURL = URL.createObjectURL(blob);
        captureHandwrittenContent(response, captureAndSubmit, exportedData);
        // setData((prevData) => ({
        //   ...prevData,
        //   src: response,
        // }));
      });
    } catch (error) {
      console.error("Error capturing snapshot:", error);
      // Handle the error here if needed
    }
  };

  function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  // const handleSubmit = async () => {
  //   setDisableBtns(true);
  //   const captureAndSubmit = true;
  //   captureSnapshot(captureAndSubmit);
  //   setDisableBtns(false);
  // };

  const handleSubmit = async () => {
    try {
      if (!editorRef.current.editor.isEmpty) {
        setIsLoading(true);
        setTimeout(() => {
          editorRef.current.editor
            .export_()
            .then(async (result) => {
              // console.log('result', result);
            })
            .catch((error) => {
              console.log("error", error);
            });
          setIsLoading(false);
        }, 2000);
      } else {
        alert("Please write content to save");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const onResult = 
    async(exports) => {
    let data = {
      latex: "",
      mathml: "",
    };
    if (
      exports &&
      exports["application/x-latex"] &&
      exports["application/mathml+xml"]
    ) {
      const latexData = exports["application/x-latex"];
      const mathmlData = exports["application/mathml+xml"];
      console.log("exports", latexData, mathmlData);
      // Remove the "\\(" and "\\)" delimiters from the latexData
      const latexWithoutDelimiters = latexData.replace(
        /\\\( (.+?) \\\)/g,
        "$1"
      );
      data = {
        latex: latexWithoutDelimiters,
        mathml: mathmlData,
      };
      setData(data);
    } else {
      setData(data);
    }

    // move it inside exported event
    setDisableBtns(true);
    const captureAndSubmit = true;
    // put try/catch black and do proper handling
    await captureSnapshot(captureAndSubmit, data);
    setDisableBtns(false);
  };

  useEffect(() => {
    let loaderElement = document.getElementsByClassName("loader");
    if (loaderElement && loaderElement.length) {
      if (isLoading) {
        loaderElement[0].style.display = "block";
      } else {
        loaderElement[0].style.display = "none";
      }
    }
  }, [isLoading]);

  useEffect(() => {
    let editor = null;
    let iink = window.iink;
    const initializeEditor = () => {
      const defaultLevel = 'DEBUG';
      Object.keys(iink.Constants.Logger).forEach((key) => {
        const name = iink.Constants.Logger[key];
        const logger = iink.LoggerConfig.getLogger(name);
        logger.setLevel(defaultLevel, false);
      });
      editorRef.current.addEventListener("exported", (evt) => {
        const exports = evt.detail.exports;
        onResult(exports);
      });

      editorRef.current.addEventListener('error', (evt) => {
        console.log('error event', evt);
      });

      editorRef.current.addEventListener("changed", (event) => {
        setDisableBtns(!event.detail.canUndo);
      });

      editor = iink.register(editorRef.current, {
        triggers: {
          exportContent: "DEMAND",
        },
        recognitionParams: {
          type: "MATH",
          protocol: "WEBSOCKET",
          apiVersion: "V4",
          server: {
            scheme: "https",
            host: "webdemoapi.myscript.com",
            applicationKey: "b60ae0a8-57ff-4ea3-aa6e-c7efb38c1aa2",
            hmacKey: "bd5d6134-52b1-49b0-9e39-796b963c790b",
          },
          websocket: {
            pingEnabled: false,
            autoReconnect: true
          }
        },
      });
      setEditorInstance(editor);

      window.addEventListener("resize", () => {
        if (editor) {
          editor.resize();
        }
      });
    };
    initializeEditor();

    return () => {
      window.removeEventListener("resize", () => {
        if (editor) {
          editor.resize();
        }
      });
      if (editor) {
        console.log("close editor");
        editor.close();
      }
    };
  }, []);

  return (
    <div className={"writingPad " + (fullScreen ? "fullScreen" : "normal")}>
      <div className="writingPadWrapper">
        <div className="editor" ref={editorRef} touch-action="none">
          {" "}
        </div>
        <div className="bottom-bar">
          <Button
            className={`CustomButton float-l ${disableBtns ? "hidden" : ""}`}
            variant="contained"
            size="large"
            ref={undoRef}
            onClick={() => {
              if (role === "Student") {
                onUndo();
                if (data.latex) {
                  clearPad();
                }
              } else {
                editorInstance.undo();
              }
            }}
          >
            {role === "Student" ? "Undo Step" : "Undo"}
          </Button>
          <div className="buttonWrapper">
            <Button
              className={`CustomButton float-l ${disableBtns ? "hidden" : ""}`}
              style={{ marginLeft: "10px" }}
              variant="contained"
              size="large"
              onClick={clearPad}
            >
              Clear
            </Button>
            <Button
              className={`CustomButton float-r  ${disableBtns ? "hidden" : ""}`}
              variant="contained"
              size="large"
              onClick={handleSubmit}
              style={{ marginLeft: "10px" }}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : submitBtnText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WritingPad;
